<template>
  <div class="ws-content-title">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>